
import {
getItemDetail,
cancalCollect,
addCollect
} from '../../api';
import Scroller from 'vux/src/components/scroller/index.vue'

export default {
data() {
return {
commodityParams: false,
detailHtml: ""
}
},
components: {
Scroller
},
props: ['data', 'like', 'channel'],
mounted() {

this.getDetailInfo();
},
computed: {
likeList() {
let list = this.like.list;
for (let i = 0; i < list.length; i++) {
list[i].text = list[i].title.substr(0, 4);
};
return list;
}
},
methods: {
toPage(id) {
this.$emit('update', {
id: id
});
this.$router.push({
name: 'detail',
params: {
id: id
}
});
},
collect() {

let that = this;

this.$store.commit('showIsLoading');
if (!this.data.is_fav) {
addCollect(`item_id=${this.data.item_info.item_id}`).then(res => {
if (res.data.error_code != 0) {
alert(res.data.msg);
return;
};
this.$store.commit('updateToast', {
text: '收藏成功',
show: true
});
this.data.is_fav = 1;
});
} else {
cancalCollect(`item_id=${this.data.item_info.item_id}`).then(res => {
if (res.data.error_code != 0) {
alert(res.data.msg);
return;
};
this.$store.commit('updateToast', {
text: '取消收藏',
show: true
});
this.data.is_fav = 0;
});
};


},
getDetailInfo() {







}
}

}



// WEBPACK FOOTER //
// ./src/components/Detail/Content.vue